import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/servicios/one-vigilance/qppv-representante-local")({
  head: () => buildRouteHead("/es/servicios/one-vigilance/qppv-representante-local", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/es/servicios/farmacovigilancia/qppv-representante-local", replace: true });
  },
});
